export default [
  {
    title: "User Management",
    customIcon: "FriendSVG",
    children: [
      {
        title: "Roles",
        route: "custom-user-management-role-list",
        path: "/custom-user-management/role-list",
      },
      {
        title: "User Access",
        route: "custom-user-management-user-access-list",
        path: "/custom-user-management/user-access-list",
      },
    ],
  },
];
